/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EditionEnum } from './editionEnum';
import { CommerceModeEnum } from './commerceModeEnum';


export interface ComponentConfigSpecCommerce { 
    agent_mode?: CommerceModeEnum;
    edition?: EditionEnum;
    features?: Array<string>;
    mode?: CommerceModeEnum;
    valid_until?: Date;
}
export namespace ComponentConfigSpecCommerce {
}


